import * as React from "react"
import { ChakraProvider } from "@chakra-ui/react"
import { ApolloProvider } from "@apollo/client"
import client from "./src/apollo/client"
import theme from "./src/utils/theme"

export const wrapRootElement = ({ element }) => (
  <ApolloProvider client={client}>
    <ChakraProvider theme={theme}>{element}</ChakraProvider>
  </ApolloProvider>
)
